<template>
  <v-container class="pa-0">
    <v-toolbar flat>
      <v-toolbar-title>Discount</v-toolbar-title>

      <v-spacer />

      <!-- Add Coupon -->
      <customer-discount-update-dialog
        v-if="!hasDiscount && !isLoading"
        :customer="customer"
        @action="onUpdateCoupon($event)"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            class="mr-2"
            :block="$vuetify.breakpoint.smAndDown"
            v-on="on"
          >
            <v-icon left>
              add
            </v-icon>

            Add Coupon
          </v-btn>
        </template>
      </customer-discount-update-dialog>

      <!-- Change Coupon -->
      <customer-discount-update-dialog
        v-if="hasDiscount && !isLoading"
        :customer="customer"
        :current-coupon="coupon.id"
        @action="onUpdateCoupon($event)"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            class="mr-2"
            v-on="on"
          >
            <v-icon left>
              edit
            </v-icon>

            Change Coupon
          </v-btn>
        </template>
      </customer-discount-update-dialog>

      <customer-discount-delete-dialog
        v-if="hasDiscount && !isLoading"
        :customer="customer"
        @action="onDeleteCoupon()"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon left>
              close
            </v-icon>

            Remove Coupon
          </v-btn>
        </template>
      </customer-discount-delete-dialog>
    </v-toolbar>

    <v-divider class="" />

    <v-container v-if="!isLoading">
      <v-alert
        v-if="hasDiscount"
        border="left"
        colored-border
        outlined
        icon="local_offer"
      >
        <v-list class="pa-0">
          <v-list-item>
            <v-list-item-content class="pa-0">
              <v-list-item-title>
                {{ coupon.name }} <span class="grey--text caption">({{ coupon.id }})</span>
              </v-list-item-title>
              <v-list-item-subtitle>{{ terms }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-alert>
      <v-row v-if="!hasDiscount">
        <v-col cols="12">
          <v-row
            align="center"
            justify="center"
          >
            <span class="title">No active discount</span>
          </v-row>
        </v-col>
      </v-row>
    </v-container>

    <v-container v-if="isLoading">
      <v-layout
        align-center
        justify-center
        row
        fill-height
      >
        <v-progress-circular
          :size="125"
          :width="7"
          color="primary"
          indeterminate
        />
      </v-layout>
    </v-container>
  </v-container>
</template>
<script>
import { get, isEmpty } from 'lodash'
import { mapActions } from 'vuex'
import CustomerDiscountDeleteDialog from "./CustomerDiscountDeleteDialog"
import CustomerDiscountUpdateDialog from "./CustomerDiscountUpdateDialog"
import { readableCouponTerms } from "../../services/stripe.service"

export default {
  components: { CustomerDiscountUpdateDialog, CustomerDiscountDeleteDialog },
  props: {
    initCustomer: {
      type: Object,
      default: () => ({})
    }
  },
  async created() {

    console.log('started with', this.initCustomer)

    // If no initial customer was provided, the user may be loading the tab directly
    if (isEmpty(this.initCustomer)) {
      this.isLoading = true
      const payload = {
        id: this.$route.params.id
      }
      const customer = await this.getCustomer(payload)
        .finally(() => {
          this.isLoading = false
        })

      this.customer = customer || {}
    } else {
      this.customer = this.initCustomer
    }

    this.coupon = get(this.customer, 'discount.coupon', {})
  },
  methods: {
    ...mapActions([ 'getCustomer' ]),
    onUpdateCoupon(customer) {
      console.log('updating', customer)
      if (customer) {
        this.customer = customer || {}
        this.coupon = get(customer, 'discount.coupon', {})
      }
    },
    onDeleteCoupon() {
      const customerClone = { ...this.customer }
      customerClone.discount = null
      this.customer = customerClone
      this.coupon = {}
    }
  },
  data() {
    return {
      coupon: {},
      customer: {},
      isLoading: false,
    }
  },
  computed: {
    hasDiscount() {
      return !isEmpty(this.type)
    },
    type() {
      return get(this.coupon, 'object', '')
    },
    terms() {
      return readableCouponTerms(this.coupon)
    }
  }
}
</script>
